import { BaseModel } from '../base-model';

export interface IPropertySmartSuggest {
  FieldCategory?: string;
  FieldId?: number;
  FieldName?: string;
  IconUrl?: string;
  NameEN?: string;
  NameFR?: string;
  NameNL?: string;
  Reference?: string;
  SuggestNameEN?: string;
  SuggestNameFR?: string;
  SuggestNameNL?: string;
}
export class ProperTySmartSuggest extends BaseModel<IPropertySmartSuggest> implements IPropertySmartSuggest {
  FieldCategory: string;
  FieldId: number;
  FieldName: string;
  IconUrl: string;
  NameEN: string;
  NameFR: string;
  NameNL: string;
  Reference: string;
  SuggestNameEN: string;
  SuggestNameFR: string;
  SuggestNameNL: string;
  /**
   *
   */
  constructor(option: IPropertySmartSuggest) {
    super(option);
  }
}